import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white p-8 relative z-10">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* About Section */}
        <div className="cursor-pointer">
          <h3 className="text-xl font-semibold mb-4">About Us</h3>
          <p className="text-lg">
            Welcome to DiDRoute, a leading Northern American Telecommunication
            Service Provider that specializes in providing Toll-Free Numbers to
            businesses of all sizes. We started back in 2015 and have become a
            trusted name for top-notch telecommunication services, serving
            clients with excellence.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="cursor-pointer">
          <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link
                to="/"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/toll-free-number"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                Toll Free Number
              </Link>
            </li>
            <li>
              <Link
                to="/did"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                DID
              </Link>
            </li>
            <li>
              <Link
                to="/inbound-solution"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                Inbound Solution
              </Link>
            </li>
            <li>
              <Link
                to="/outbound-solution"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                Outbound Solution
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-yellow-500 transition-colors duration-300"
                onClick={() => window.scrollTo(0, 0)}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
          <p className="text-lg mb-2">
            Email:{" "}
            <a
              href="mailto:info@DiDroute.com"
              className="text-yellow-500 hover:text-yellow-400 transition-colors duration-300"
            >
              info@DiDRoute.com
            </a>
          </p>
          <p className="text-lg">
            Phone:{" "}
            <a
              href="tel:+1234567890"
              className="text-yellow-500 hover:text-yellow-400 transition-colors duration-300"
            >
              +1-866-345-8151
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-gray-700 mt-8 pt-4 text-center">
        <p className="text-lg">
          &copy; DiDRoute.com | All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
